<script>
import abstractField from '../abstractField';
import { h, resolveComponent } from 'vue';

export default {
  name: 'field-button',
  mixins: [abstractField],
  methods: {
    onClick($event) {
      this.schema.onClick(this.model, this.schema, $event);
    }
  },
  render() {
    const legoButton = resolveComponent('lego-button');
    return h(
      legoButton,
      {
        xs: this.schema.xs,
        sm: this.schema.sm,
        md: this.schema.md,
        disabled: this.schema.disabled,
        class: this.schema.fieldClasses,
        onClick: this.onClick
      },
      [this.schema.label]
    );
  }
};
</script>
